import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { momentFormat, serverFormatWithTimezone } from "../utils/dates";

const styles = {
  summary: {
    "& p": { my: 0.5 },
    "& ul, & ol": { my: 0.5, pl: 2.5 },
    "& li": { mb: 0.25 },
    "& strong": { fontWeight: 600 },
  },
  diff: {
    mt: 1,
    py: 0.75,
    borderRadius: 1,
    bgcolor: "background.default",
    fontSize: "0.875rem",
    overflowX: "auto",
    "& p": { my: 0.25 },
  },
};

export default function RevisionLogItem({ log }) {
  return (
    <Box
      mb={1.5}
      borderRadius={1}
      border="1px solid"
      borderColor="divider"
      px={1.5}
      py={1}
      bgcolor="white"
    >
      <Box>
        <Box display="flex" justifyContent="space-between" alignItems="baseline" gap={2}>
          <Box>
            {log.summaryPretty && (
              <Box
                className="summary"
                sx={styles.summary}
                dangerouslySetInnerHTML={{
                  __html: log.summaryPretty.replace(/<p>&nbsp;↳ /, "").replace("✎", ""),
                }}
              />
            )}
          </Box>
          <Typography variant="body2" color="text.secondary">
            {moment(log.performedAt, serverFormatWithTimezone).format(momentFormat)}
          </Typography>
        </Box>
        {log.diffPretty && (
          <Box
            className="diff"
            sx={styles.diff}
            dangerouslySetInnerHTML={{
              __html: log.diffPretty.replaceAll("&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", ""),
            }}
          />
        )}
      </Box>
    </Box>
  );
}
